import { atom, selector } from 'recoil';
import { Distributors } from '@/sdk/data-contracts';

export const distributorListRecoil = atom<Distributors[]>({
  key: 'distributorListRecoil',
  default: [],
});

// export const eventDetailRecoil = atom<GetDetailSiteDtoRx | null>({
//   key: 'eventDetailRecoil',
//   default: null,
// });

// export const eventDetailIdRecoil = atom<number | null>({
//   key: 'eventDetailIdRecoil',
//   default: null,
// });
